export default __webpack_public_path__ + "static/media/plgespc_statue-of-unity_625x300_31_October_18.b144f0f8.webp";